export const activityRecordTypes = [
    "placement",
    "homeCare",
    "community",
    "referenceContact",
    "referenceBusiness",
];
export const activityRecordTypeLabels = {
    placement: "Clients",
    homeCare: "Home Care Clients",
    community: "Communities",
    referenceContact: "Referral Contacts",
    referenceBusiness: "Referral Organizations",
};
export const activityRecordTypeSingularLabels = {
    placement: "Client",
    homeCare: "Home Care Client",
    community: "Community",
    referenceContact: "Referral Contact",
    referenceBusiness: "Referral Organization",
};
export const allActivityRecordTypes = () => [
    ...activityRecordTypes,
];
export const isActivityRecordType = (value) => activityRecordTypes.includes(value);
export const asActivityRecordTypes = (values) => activityRecordTypes.filter(recordType => values.includes(recordType));
export const activityRecordTypeForGoalMetricItemLinkKind = {
    placement: "placement",
    homeCare: "homeCare",
    community: "community",
    referenceContact: "referenceContact",
    referenceBusiness: "referenceBusiness",
};
//# sourceMappingURL=activity-record-type.js.map